import { render, staticRenderFns } from "./pageBuilderWarp.vue?vue&type=template&id=2384961e&scoped=true&"
import script from "./pageBuilderWarp.vue?vue&type=script&lang=js&"
export * from "./pageBuilderWarp.vue?vue&type=script&lang=js&"
import style0 from "./pageBuilderWarp.vue?vue&type=style&index=0&id=2384961e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384961e",
  null
  
)

export default component.exports